interface TopbarProps {
  onMenuClick: () => void;
}

export default function Topbar({ onMenuClick }: TopbarProps) {
  return (
    <header className="h-14 md:h-16 bg-dark-950/80 backdrop-blur-md border-b border-white/5 sticky top-0 z-30 flex items-center justify-between px-3 md:px-6">
      <div className="flex items-center gap-3">
        {/* Hamburger - mobile only */}
        <button
          onClick={onMenuClick}
          className="lg:hidden w-9 h-9 flex items-center justify-center text-gray-400 hover:text-gold-400 transition-colors rounded-lg hover:bg-white/5 cursor-pointer"
        >
          <i className="ri-menu-line text-lg" />
        </button>
        <h2 className="text-gray-100 font-medium text-sm">KuyumPro Panel</h2>
        <span className="hidden sm:inline text-xs text-gray-500 bg-white/5 px-2 py-0.5 rounded-full">v1.0</span>
      </div>
      <div className="flex items-center gap-2 md:gap-4">
        {/* Search */}
        <div className="hidden md:flex items-center gap-2 bg-white/5 border border-white/10 rounded-lg px-3 py-1.5">
          <i className="ri-search-line text-gray-500 text-sm" />
          <input
            type="text"
            placeholder="Ara..."
            className="bg-transparent text-sm text-gray-300 placeholder-gray-500 outline-none w-40"
          />
        </div>
        {/* Notification */}
        <button className="relative w-9 h-9 flex items-center justify-center text-gray-400 hover:text-gold-400 transition-colors rounded-lg hover:bg-white/5 cursor-pointer">
          <i className="ri-notification-3-line text-lg" />
          <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-gold-500 rounded-full" />
        </button>
        {/* User */}
        <div className="flex items-center gap-2.5">
          <div className="w-8 h-8 rounded-full bg-gradient-to-br from-gold-500 to-gold-700 flex items-center justify-center text-white text-xs font-semibold">
            AD
          </div>
          <div className="hidden sm:block">
            <p className="text-xs text-gray-300 font-medium">Ahmet Düzgün</p>
            <p className="text-[10px] text-gray-500">Yönetici</p>
          </div>
        </div>
      </div>
    </header>
  );
}